/* eslint-disable max-lines */
import { clearURLParams } from 'actions';
import { fetchCohorts } from 'actions/cohorts';
import DropdownFilter from 'components/Filters/DropdownFilter/DropdownFilter';
import UserInactiveFilter from 'components/Filters/UserInactiveFilter';
import UserIntegrationFilter from 'components/Filters/UserIntegrationFilter';
import UserTeamsFilter from 'components/Filters/UserTeamsFilter';
import SearchInput from 'components/SearchInput';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getCohorts, getCohortsLoading } from 'selectors/cohorts';

const MonitoredUsersFilters: React.FC = () => {
  const dispatch = useDispatch();

  const handleClearFilters = (): void => {
    dispatch(clearURLParams());
  };

  return (
    <div className="flex flex-row gap-2 flex-wrap">
      <SearchInput
        resource={resourceQueryParamName.user}
        field="broad_search"
        className="h-8 max-w-68"
        placeholder="Search users by name or email"
      />

      <div className="w-26">
        <UserTeamsFilter kind="management-level" resource={resourceQueryParamName.user} />
      </div>
      <div className="w-26">
        <DropdownFilter
          resource={resourceQueryParamName.user}
          fetchAction={fetchCohorts}
          filterKey="cohort_uuids"
          itemField="uuid"
          getResourceList={getCohorts}
          getLoading={getCohortsLoading}
          title="Cohort"
          nameKey="name"
          notFoundText="No cohorts found"
          searchKey="broad_search"
        />
      </div>
      <div className="w-26">
        <UserTeamsFilter kind="division" resource={resourceQueryParamName.user} />
      </div>
      <div className="w-26">
        <UserTeamsFilter kind="region" resource={resourceQueryParamName.user} />
      </div>

      <UserIntegrationFilter resource={resourceQueryParamName.user} />
      <UserInactiveFilter resource={resourceQueryParamName.user} />
      <button
        type="button"
        className="text-body self-end focus:outline-none"
        onClick={handleClearFilters}
      >
        <span className="text-litlingo-primary underline">Clear All</span>
      </button>
    </div>
  );
};

export default MonitoredUsersFilters;
